import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { URL } from '../../environments/environment';
import { Applications } from '../interfaces/application';

@Injectable({ providedIn: 'root' })
export class ApplicationsService {
  private readonly http = inject(HttpClient);

  applicationsChanged: Subject<boolean> = new Subject<boolean>();

  myObject: Applications;

  /****************************************************************************
   * Get all applications EAGER                                               *
   *                                                                          *
   * @returns {Observable<Applications[]>} an array of all the applications   *
   ****************************************************************************/
  getApplications(): Observable<Applications[]> {
    return this.http.get<Applications[]>(`${URL.url}${URL.applications}`);
  }

  /**********************************************************************
   * Add an application                                                 *
   *                                                                    *
   * @param application - The application that will be added            *
   * @returns {Observable<Applications>} The application that was added *
   **********************************************************************/
  addApplications(application: Applications): Observable<Applications> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(application);
    return this.http.post<Applications>(`${URL.url}${URL.applications}`, body, { headers });
  }

  /*****************************************************************
   * Get the application using the name of the application         *
   *                                                               *
   * @param applicationName - The name of the application          *
   * @returns {Observable<Applications>}                           *
   *****************************************************************/
  getApplicationByName(applicationName: string): Observable<Applications> {
    console.log('applicationName', applicationName);
    return this.http.get<Applications>(`${URL.url}${URL.applications}/${applicationName}`);
  }

  /*************************************************************
   * Update the application                                    *
   *                                                           *
   * @param id The ID of the application                       *
   * @param updateApplication - The updated Application        *
   * @returns {Observable<any>}                                *
   *************************************************************/
  updateApplication(id: number, updateApplication: Applications): Observable<void> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(updateApplication);
    return this.http.put<void>(`${URL.url}${URL.applications}/${id}/status`, body, { headers });
  }

  /********************************************
   * Remove the Application by id             *
   *                                          *
   * @param id - The ID of the application    *
   * @returns {Observable<any>}               *
   ********************************************/
  removeById(id: number): Observable<any> {
    return this.http.delete(`${URL.url}${URL.applications}/${id}`);
  }

  /************************************************
   * Get all the applications with the Lazy type  *
   *                                              *
   * @returns {Observable<Applications[]>}        *
   ************************************************/
  getLazyApplications(): Observable<Applications[]> {
    return this.http.get<Applications[]>(`${URL.url}applicationsLazy`);
  }
}
